var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"float-btn"},[(_vm.selectedAccount)?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'Support', params: { user_uid: _vm.selectedAccount } }}},[_c('svgicon',{attrs:{"name":"support","fill":true}})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5340a056","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/FloatSupport.vue
// module id = null
// module chunks = 